var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"stripeElement",staticClass:"form-input-group payment-method",attrs:{"id":"stripe-payment-element"},on:{"submit":function($event){$event.preventDefault();_vm.$emit('submit')}}})}
var staticRenderFns = []

export { render, staticRenderFns }